"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _TrustpayWithdrawWorkflowComponent = _interopRequireDefault(require("./TrustpayWithdrawWorkflowComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  return {
    url: state.withdraw.withdrawWorkflowInfo && state.withdraw.withdrawWorkflowInfo.URL
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(_TrustpayWithdrawWorkflowComponent["default"]);